module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGPC/xhBQAAAQpJREFUWAljZCAATExMtv3//9+TgDKypBkZGRcxkaWTipoG3AEshDzDxMQ0++/fv3sJqSNBvhioVhKmnhHGoBdtbGx8EWiXHsi+0TQACoWBT4SgfA5yCS0AMI47Tp8+fQif2Sy0KmRAlgIdsBCf5SC5gY8CNBfeAfIfoYkRzQX6mB0YotZEawAqRC+IZpw9e7aXFAOQ1VpbW0v9+PHjKbIYIfaAR8GoA0ZDYDQERkNgwEMAvSgmVHJSLM/MzFwGrC8EQAb9+/fvAd0dcOrUqZ3IvhjwKBh1AHoaKAa22+OQ44gUNrAtwEqKepBadAeAeizwXguphpGjfsDTAAuoe0SOy4nRA8rnhNQBAEhjNkE6EW+VAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/_asset/sources/assets/images/copy_black_transparent_16_16.png
// module id = ./src/_asset/sources/assets/images/copy_black_transparent_16_16.png
// module chunks = main